import {FillObjectStrategy} from "../../../_types/FillObjectStrategy";
import type {FillProperty} from "../../../_types/FillProperty";
import type {SceneObjectWithColorData} from "../../../_types/SceneObjectWithColorData";
import type {Size} from "../../../_types/Size";
import type {WebGLRenderObject} from "../../../_types/WebGLRenderObject";
import {getRandomNumberBetween} from "../../../helpers/getRandomNumberBetween";
import type {ObjectPipelinePass} from "../../ObjectPipeline";
import {FrameFillObjectStrategy} from "./strategies/FrameFillObjectStrategy";
import {PatternFillObjectStrategy} from "./strategies/PatternFillObjectStrategy";

export class FillObjectPass implements ObjectPipelinePass {

    constructor(
        private sceneSize: Size,
        private options: FillProperty) {}

    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    public apply(
        index: number,
        renderObject: WebGLRenderObject,
        sceneObjects: Array<SceneObjectWithColorData>
    ): void {

        const diagonal = Math.sqrt(
            Math.pow(this.sceneSize.width, 2) + Math.pow(this.sceneSize.height, 2));

        const fillObjectStrategy = getFillObjectStrategyFromFillMode(this.options);
        const position = fillObjectStrategy.getPosition(index, this.sceneSize);

        if (this.options.randomize) {

            position.x += getRandomNumberBetween(
                (diagonal * 0.05) * -this.options.randomize,
                (diagonal * 0.05) * this.options.randomize);

            position.y += getRandomNumberBetween(
                (diagonal * 0.05) * -this.options.randomize,
                (diagonal * 0.05) * this.options.randomize);
        }

        renderObject.x = position.x;
        renderObject.y = position.y;
    }
}

const colorModeToColorObjectStrategyMap: Record<string, any> = {
    "frame": FrameFillObjectStrategy,
    "pattern": PatternFillObjectStrategy
};

const getFillObjectStrategyFromFillMode = (fillProperty: FillProperty): FillObjectStrategy => {

    const FillObjectStrategy = colorModeToColorObjectStrategyMap[fillProperty.mode];

    if (!FillObjectStrategy) {
        throw new Error(`No fill object strategy for fill mode '${fillProperty.mode}'`);
    }

    return new FillObjectStrategy(fillProperty.options);
};